import { render, staticRenderFns } from "./LoginGuard.vue?vue&type=template&id=1ca15870&"
import script from "./LoginGuard.vue?vue&type=script&lang=js&"
export * from "./LoginGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports